export default __webpack_public_path__ + "static/media/4.e4994a58.jpg";